import firebase from 'firebase/compat/app';
import {
    getDocs,
    query,
    collection,
    where,
    QueryConstraint,
    setDoc,
    doc,
    updateDoc
} from "firebase/firestore";
import {Project, projectFromJson} from "../../models/project/project";
import {v4 as uuidv4} from 'uuid';
import {firestore, functions} from "../../firebase";
import {httpsCallable} from "firebase/functions";
import {Staff} from "../../models/staff/staff";

export class ProjectFirestore {


    async getProjects(businessId: string, staff: Staff) {
        try {
            const whereClauses: QueryConstraint[] = []
            whereClauses.push(where("businessId", "==", businessId), where("isDeleted", "==", false))
            const q = query(collection(firestore, "project"), ...whereClauses);

            const querySnapshot = await getDocs(q)
            const data: Project[] = []
            querySnapshot.docs.forEach(doc => {
                const projectData = projectFromJson(doc.data())
                if(staff.role === "owner" || staff.projectIds.includes(projectData.id)) {
                    data.push(projectData)
                }
            })

            return {kind: "ok", data}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }

    async addProject(formData: {
        name: string, walletAddress: string
    }, businessId: string, addFunds: boolean) {
        try {
            const uuid = uuidv4();
            const millis = Date.now();
            const id = `${uuid}-${millis}`

            const projectData = {
                ...formData,
                logoUrl: "",
                apiKey: uuidv4(),
                id,
                businessId,
                isDeleted: false,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }

            await setDoc(doc(firestore, "project", id), projectData)

            if (addFunds) {
                const initProjectWalletFunction = httpsCallable<{
                    projectId: string
                }, string>(functions, "initProjectWallet");

                initProjectWalletFunction({
                    projectId: id
                });
            }

            return {kind: "ok"}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }

    async updateProject(id: string, formData: {
        name: string, walletAddress: string
    }) {
        try {

            const projectData = {
                ...formData,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }

            await updateDoc(doc(firestore, "project", id), projectData)

            return {kind: "ok"}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }

    async revokeProjectApiKey(id: string, newApiKey: string) {
        try {
            const projectData = {
                apiKey: newApiKey,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }

            await updateDoc(doc(firestore, "project", id), projectData)

            return {kind: "ok"}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }

    async deleteProject(id: string) {
        try {
            const projectData = {
                isDeleted: true,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }

            await updateDoc(doc(firestore, "project", id), projectData)

            return {kind: "ok"}

        } catch (e) {
            console.log(e)
            return {kind: "bad-data"}
        }
    }
}
